export default function Hotellist(){

    return(
        <>
        <div>hiiii</div>
        </>
    )
}